import { NotificationStyles } from '@models/notifications/NotificationStyles.interface';

/**
 * Toast style.
 */
export const NotificationStyle: NotificationStyles = {
  simple: 'simple',
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  async: 'async',
  confirm: 'confirm',
  prompt: 'prompt'
};
